import { ChakraProps } from "@chakra-ui/react"

export const FormStyleConfig:ChakraProps = {
    h: "100%",
    maxH: "100%",
    pos: "relative",
    pt: "3%"
}
 
export const BoxStyleConfig:ChakraProps = {
    h: "50%",
    w: "100%",
    display: "flex",
    flexDir: "column",
    justifyContent: "flex-start",
    alignSelf: "flex-start"
}

export const BoxRowStyleConfig:ChakraProps = {
    h: "50%",
    w: "100%",
    display: "flex",
    flexDir: "row",
    justifyContent: "flex-start",
    alignSelf: "flex-start"
}
